import FormHelperText from '@mui/material/FormHelperText';

interface PasswordErrorListProps {
  errors: string[];
  id: string;
}

export default function PasswordErrorList({ errors, id }: PasswordErrorListProps) {
  if (!errors || errors.length === 0) {
    return null;
  }

  return (
    <FormHelperText error component='div' id={id} role='alert' aria-live='polite'>
      <ul style={{ margin: 0, paddingLeft: 20 }}>
        {errors.map((err, index) => (
          <li key={index}>{err}</li>
        ))}
      </ul>
    </FormHelperText>
  );
}
